import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

import { unMaskCurrency } from '@utils/masks/unMaskCurrency'

export const newSimulationModalSchema = yupResolver(
  yup.object({
    simulationType: yup
      .string()
      .oneOf(['ADMISSAO', 'RESCISAO', ''], 'Tipo de simulação é obrigatório')
      .required('Tipo de simulação é obrigatório'),
    nome: yup
      .string()
      .when('simulationType', {
        is: 'RESCISAO',
        then: (schema) => schema.required('Nome é obrigatório'),
        otherwise: (schema) => schema.notRequired()
      }),
    cargo: yup
      .string()
      .when('simulationType', {
        is: 'ADMISSAO',
        then: (schema) => schema.required('Cargo é obrigatório'),
        otherwise: (schema) => schema.notRequired()
      }),
    dataInicioAdmissao: yup
      .string()
      .when('simulationType', {
        is: 'ADMISSAO',
        then: (schema) => schema.required('Data de início é obrigatória'),
        otherwise: (schema) => schema.notRequired()
      }),
    salarioAdmissao: yup
      .string()
      .when('simulationType', {
        is: 'ADMISSAO',
        then: (schema) =>
          schema
            .required('Salário é obrigatório')
            .test('positive', 'O salário deve ser maior que zero.', (value) => {
              if (!value) return true
              return unMaskCurrency(value) > 0
            }),
        otherwise: (schema) => schema.notRequired()
      }),
    semJustaCausa: yup.boolean().required()
  })
)
